import { FaceEnrollmentModal } from "@/modules/face-enrollment/components/FaceEnrollmentModal";
import { FaceEnrollmentTable } from "@/modules/face-enrollment/components/FaceEnrollmentTable";
import { useUrlTableState } from "@/shared/hooks/useUrlState";

interface OrgFaceEnrollmentTabProps {
	organizationId: string;
}

export function OrgFaceEnrollmentTab({ organizationId }: OrgFaceEnrollmentTabProps) {
	const { page, limit, setPage } = useUrlTableState({ prefix: "face" });

	return (
		<>
			<FaceEnrollmentTable
				organizationId={organizationId}
				page={page}
				limit={limit}
				onPageChange={setPage}
			/>
			<FaceEnrollmentModal organizationId={organizationId} />
		</>
	);
}
